import React, { Component } from "react";
import queryString from "query-string";
import { getRef } from "../../helpers/utils";

// sub-components
import Contain from "../contain";

import { Img, HeroSection, Headline, Description } from "./styles";

class Hero extends Component {
  state = {
    showVideo: false,
    registerUrl: "https://quickpageapp.com/register?qpc=qpre",
  };

  toggleVideo = () => {
    this.setState({ showVideo: !this.state.showVideo });
  };

  componentDidMount() {
    const ref =
      getRef(this.props.location) ||
      queryString.parse(this.props.location.search).ref;

    if (ref) {
      this.setState({
        registerUrl: `https://quickpageapp.com/register?ref=${ref}&qpc=qpre&qpi=real-estate&qphab=kwrur`,
      });
    }
  }

  render() {
    const { description } = this.props;

    return (
      <HeroSection>
        <Contain column>
          <Img
            src="https://s3.amazonaws.com/cdn.quickpageapp.com/public/kw.png"
            alt="KW"
          />
          <Headline>
            Capture, convert and close more clients with <span>Quickpage</span>
          </Headline>

          <Description>{description}</Description>
        </Contain>
      </HeroSection>
    );
  }
}

export default Hero;
